"use client";
import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
import dialogImgTr from "~/assets/images/livechatTicket/dialog-tr.png?url";
import dialogImg from "~/assets/images/livechatTicket/dialog.png?url";
import heroContentImg1 from "~/assets/images/livechatTicket/hero-content-img1.png?url";
import Image from "~/common/components/CustomImage";
import PricingOfferButton from "~/app/[locale]/pricing/components/PricingOfferButton";

import styles from "./LiveChatTicketSection1.module.scss";

const LiveChatTicketSection1 = ({ locale, title, description }) => {
  const { t } = useTranslation();

  return (
    <div className={clsx(styles.chatbotSection1, "card")}>
      {/* reuse class names for styling consistency */}
      <div className={styles.chatbotSection1Content}>
        <div className={styles.chatbotSection1ContentLeft}>
          <h1 className={clsx("pal-section-title", styles.chatbotSection1Title)}>
            {title ?? t("liveChatTicket.section1.title")}
          </h1>
          <p className={clsx("pal-section-desc", styles.chatbotSection1Desc)}>
            {description ?? t("liveChatTicket.section1.description")}
          </p>
          <PricingOfferButton source="live-chat-ticket-section-1" />
        </div>
        <div className={styles.chatbotSection1ContentRight}>
          <Image src={heroContentImg1} alt={t("liveChatTicket.section1.heroImageAlt")} width={485} height={586} />
        </div>
      </div>
      <div className={styles.chatbotSection1Content2}>
        <h2 className={styles.chatbotSection1Content2Title}>{t("liveChatTicket.section1.content2.title")}</h2>
        <p className={styles.chatbotSection1Content2Desc}>{t("liveChatTicket.section1.content2.description")}</p>
        <div className={styles.chatbotSection1Content2Dialog}>
          <Image
            src={locale === "tr" ? dialogImgTr : dialogImg}
            alt={t("liveChatTicket.section1.dialogImageAlt")}
            width={1312}
            height={460}
          />
        </div>
      </div>
    </div>
  );
};

export default LiveChatTicketSection1;
